// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------

import { atualizarCotaUsuario } from "../services/atualizarCotaUsuarioService";

// --------------------- Import Interface ---------------------

import { Cota } from "../../../interfaces/Cota";

export const useVincularDados = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const vincularDados = async (
    cotaUsuarioId: number | undefined | null,
    cotaInfo: Cota
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const values = {
        cotaId: cotaInfo.id,
      };
      //Atualiza Cota Usuario
      const atualizarCTU = await atualizarCotaUsuario(cotaUsuarioId, values);
      if (atualizarCTU) {
        setSuccess("O empreendimento foi vinculado com sucesso!");
      } else {
        setError("Não foi possível vincular o empreendimento!");
      }
    } catch (error) {
      console.error(error);
      setError("Não foi possível vincular o empreendimento!");
    } finally {
      setIsLoading(false);
    }
  };

  return { vincularDados, isLoading, isSuccess, error, success };
};
